function _saveToLocal(key: string | number, value: any): void {
  let cicle: any = localStorage.__cicle__
  if (!cicle) {
    cicle = {}
  } else {
    cicle = JSON.parse(cicle)
  }
  cicle[key] = value
  localStorage.__cicle__ = JSON.stringify(cicle)
}

function _loadFromLocal(key: string | number, def?: any): any {
  let cicle: any = localStorage.__cicle__
  if (!cicle) {
    return def
  }
  cicle = JSON.parse(cicle)
  if (!cicle) {
    return def
  }
  let ret = cicle[key]
  return ret || def
}

export { _saveToLocal as saveToLocal, _loadFromLocal as loadFromLocal }
